<div class="layout-topbar" [ngClass]="{ 'topbar-show-bg': !topOfPage }">
  <a class="logo">
    <!--img style="width: 200%;" style="height: 200%;" src="assets/images/hrs-logo.png"/-->
    <img [src]="imageToShow" *ngIf="!imageIsLoading" />
  </a>
  <!-- favorites container -->
  <div class="favorites-container" [ngClass]="{ 'edit-mode-active': isEditMode, 'delete-mode-active': isDeleteMode }">
    <ng-container *ngIf="favorites$ | async as favorites">
      <ng-container *ngIf="favorites.length > 0; else noFavorites">
        <!-- favorites with Drag & Drop -->
        <div
          cdkDropList
          cdkDropListOrientation="horizontal"
          [cdkDropListDisabled]="!isEditMode || isDeleteMode"
          (cdkDropListDropped)="onDrop($event)"
          class="favorites-list"
        >
          <div
            *ngFor="let favorite of favorites"
            cdkDrag
            class="favorite-item"
            [class.edit-mode]="isEditMode && !isDeleteMode"
            [class.delete-mode]="isDeleteMode"
            (cdkDragStarted)="onDragStarted($event)"
            (cdkDragEnded)="onDragEnded($event)"
          >
            <!-- favorites-buttons -->
            <a [href]="favorite.resolvedURL$ | async" (click)="handleFavoriteClick($event, favorite)">
              <button
                class="favorite-button"
                [pTooltip]="favorite.name"
                [tooltipDisabled]="isDragging"
                tooltipPosition="bottom"
              >
                <i [class]="favorite.icon"></i>
              </button>
            </a>

            <!-- delet-button (only visible when delete-mode is active) -->
            <button
              *ngIf="isDeleteMode"
              class="remove-favorite-button"
              pTooltip="Entfernen"
              (click)="removeFavorite($event, favorite.id)"
            >
              <i class="pi pi-times"></i>
            </button>

            <!-- preview-template for fav appearance during drag & drop -->
            <ng-template cdkDragPreview id="favorite-preview">
              <div class="favorite-item">
                <button class="favorite-button">
                  <i [class]="favorite.icon"></i>
                </button>
              </div>
            </ng-template>
          </div>
        </div>

        <!-- edit controls -->
        <div class="edit-controls">
          <button
            class="edit-mode-toggle"
            pTooltip="{{ isEditMode ? 'Bearbeiten beenden' : 'Bearbeiten' }}"
            (click)="toggleEditMode()"
          >
            <i class="{{ isEditMode ? 'pi pi-check' : 'pi pi-pencil' }}"></i>
          </button>

          <!-- delete-mode toggle (only visible when edit-mode is active) -->
          <button
            *ngIf="isEditMode"
            class="delete-mode-toggle"
            [class.active]="isDeleteMode"
            pTooltip="{{ isDeleteMode ? 'Löschen beenden' : 'Löschen' }}"
            (click)="toggleDeleteMode()"
          >
            <i class="pi pi-trash"></i>
          </button>
        </div>
      </ng-container>

      <ng-template #noFavorites>
        <span class="no-favorites"></span>
      </ng-template>
    </ng-container>
  </div>
  <div class="flex align-items-center">
    <!-- user profile -->
    <div class="user-profile-text">{{ loginName }}</div>

    <div class="user-profile" *ngIf="appConfigService.getUIInfo$() | async as uiInfo">
      <!-- if use Gravatar -->
      <ng-container *ngIf="!!uiInfo.use_gravatar">
        <ng-container *ngIf="getGravatarLink$() | async as gravatarLink">
          <div
            class="topbar-avatar"
            (click)="app.onProfileButtonClick($event)"
            pTooltip="Profil"
            tooltipPosition="bottom"
          >
            <img [src]="gravatarLink" />
          </div>
        </ng-container>
      </ng-container>

      <!-- else -->
      <i
        *ngIf="!uiInfo.use_gravatar"
        class="topbar-button pi pi-user"
        (click)="app.onProfileButtonClick($event)"
        pTooltip="Profil"
        tooltipPosition="bottom"
      ></i>
    </div>

    <!-- build info -->
    <i
      class="topbar-button pi pi-info-circle"
      (click)="app.onBuildInfoButtonClick($event)"
      pTooltip="Build Information"
      tooltipPosition="bottom"
    ></i>
    <!-- logout -->
    <i
      class="topbar-button pi pi-sign-out"
      (click)="app.onLogoutButtonClick($event)"
      pTooltip="Logout"
      tooltipPosition="bottom"
    ></i>
  </div>
</div>
